export const regexValidator = {
  juiceGroup: /^[a-z][a-z0-9-]*$/,
  name: /^[a-z0-9-]*$/,
  noSpace: /^\S*$/,
};
